import { render, staticRenderFns } from "./i-prompt.vue?vue&type=template&id=c93ec164&scoped=true&"
import script from "./i-prompt.vue?vue&type=script&lang=js&"
export * from "./i-prompt.vue?vue&type=script&lang=js&"
import style0 from "./i-prompt.vue?vue&type=style&index=0&id=c93ec164&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93ec164",
  null
  
)

export default component.exports